import { useQuery } from "react-query"
import { ValidateCouponDto } from "types/dto/ValidateCouponDto"
import * as couponService from 'services/couponService';


export const useValidateCoupon = (dto: ValidateCouponDto, options = {}) => {
  return useQuery({
    queryKey: ['coupon-validation', dto],
    queryFn: () => couponService.validateCoupon(dto),
    ...options,
  })
}